/* Base translations · Install page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): install. */
export const I18N_BASE_INSTALL = {
  en: {
    // Batch 19 · Stage C · C2 (F-152): the public /install page
    install: {
      title: "Install Azex Audit on this device",
      intro: "Azex Audit installs like an app: its own icon, a full-screen window and faster opening. Your sign-in, your firm's data and your files stay on the server exactly as in the browser.",
      already: "Azex Audit is already installed on this device.",
      open: "Open Azex Audit",
      androidLead: "On Android, Chrome or Edge installs the app in one step.",
      desktopLead: "On this computer, Chrome or Edge installs the app in one step.",
      button: "Install Azex Audit",
      androidStep1: "Open the browser menu (the three dots at the top right).",
      androidStep2: "Tap \"Install app\" (or \"Add to Home screen\"), then \"Install\".",
      desktopStep1: "Click the install icon at the right end of the address bar (or the browser menu → \"Install Azex Audit\").",
      desktopStep2: "Click \"Install\". The app opens in its own window; a shortcut is added to your apps.",
      dismissed: "The install was cancelled. You can install later from this page or from the browser menu.",
      iosLead: "On iPhone and iPad, Safari adds the app to the Home Screen in three steps.",
      iosOpenSafari: "Open this page in Safari first — only Safari can add the app to the Home Screen on iPhone and iPad.",
      iosStep1: "Tap the Share button (the square with the arrow) at the bottom of Safari.",
      iosStep2: "Scroll the sheet and tap \"Add to Home Screen\".",
      iosStep3: "Tap \"Add\" at the top right. The Azex icon appears on the Home Screen.",
      macLead: "On a Mac, Safari adds the app to the Dock in three steps.",
      macStep1: "Click the Share button in Safari's toolbar (or File in the menu bar).",
      macStep2: "Choose \"Add to Dock\".",
      macStep3: "Click \"Add\". The Azex icon appears in the Dock.",
      otherBrowser: "This browser does not offer app installs. Open this page in Chrome or Edge (or Safari on an Apple device) to install Azex Audit.",
      signIn: "Sign in to Azex Audit",
      linkFromLogin: "Install Azex Audit on this device",
    },
  },
  ar: {
    // Batch 19 · Stage C · C2 (F-152): صفحة التثبيت العامة
    install: {
      title: "تثبيت Azex Audit على هذا الجهاز",
      intro: "يُثبَّت Azex Audit كتطبيق: أيقونة خاصة به، ونافذة بملء الشاشة، وفتح أسرع. يبقى تسجيل دخولك وبيانات شركتك وملفاتك على الخادم تمامًا كما في المتصفح.",
      already: "Azex Audit مثبّت بالفعل على هذا الجهاز.",
      open: "فتح Azex Audit",
      androidLead: "على أندرويد، يثبّت Chrome أو Edge التطبيق بخطوة واحدة.",
      desktopLead: "على هذا الحاسوب، يثبّت Chrome أو Edge التطبيق بخطوة واحدة.",
      button: "تثبيت Azex Audit",
      androidStep1: "افتح قائمة المتصفح (النقاط الثلاث أعلى اليمين).",
      androidStep2: "اضغط «تثبيت التطبيق» (أو «إضافة إلى الشاشة الرئيسية») ثم «تثبيت».",
      desktopStep1: "انقر أيقونة التثبيت في طرف شريط العنوان (أو قائمة المتصفح ← «تثبيت Azex Audit»).",
      desktopStep2: "انقر «تثبيت». يفتح التطبيق في نافذته الخاصة ويُضاف اختصار إلى تطبيقاتك.",
      dismissed: "أُلغي التثبيت. يمكنك التثبيت لاحقًا من هذه الصفحة أو من قائمة المتصفح.",
      iosLead: "على iPhone وiPad، يضيف Safari التطبيق إلى الشاشة الرئيسية بثلاث خطوات.",
      iosOpenSafari: "افتح هذه الصفحة في Safari أولًا — Safari وحده يضيف التطبيق إلى الشاشة الرئيسية على iPhone وiPad.",
      iosStep1: "اضغط زر المشاركة (المربع ذو السهم) أسفل Safari.",
      iosStep2: "مرّر اللوحة واضغط «إضافة إلى الشاشة الرئيسية».",
      iosStep3: "اضغط «إضافة» أعلى اليمين. تظهر أيقونة Azex على الشاشة الرئيسية.",
      macLead: "على Mac، يضيف Safari التطبيق إلى شريط Dock بثلاث خطوات.",
      macStep1: "انقر زر المشاركة في شريط أدوات Safari (أو «ملف» في شريط القوائم).",
      macStep2: "اختر «إضافة إلى Dock».",
      macStep3: "انقر «إضافة». تظهر أيقونة Azex في Dock.",
      otherBrowser: "هذا المتصفح لا يدعم تثبيت التطبيقات. افتح هذه الصفحة في Chrome أو Edge (أو Safari على أجهزة Apple) لتثبيت Azex Audit.",
      signIn: "تسجيل الدخول إلى Azex Audit",
      linkFromLogin: "تثبيت Azex Audit على هذا الجهاز",
    },
  },
};

export default I18N_BASE_INSTALL;
